import { reportingServices } from "@adapters/api/services/ReportingService";

export const postError = async (error: string): Promise<void> => {
  try {
    await reportingServices.error(error);
  } catch (err: unknown) {
    /* empty */
  }
};
